// extracted by mini-css-extract-plugin
export default {"root":"LandscapesGrid_root__AbhGa","landscapeCardHolder":"LandscapesGrid_landscapeCardHolder__50Cpn","landscapeCard":"LandscapesGrid_landscapeCard__BZVcq"};